module.exports = __webpack_public_path__ + "img/THUMBNAILnotext.33b118c9.png";